import { z } from 'zod';

const optStr = (max = 200) => z.preprocess(
    (v) => (v === null || v === undefined ? undefined : v),
    z.string().max(max).optional().or(z.literal(''))
);

// Form schema
export const materialFormSchema = z.object({
    materialId: optStr(30),
    name: z.string().min(1, 'Tên vật tư không được để trống').max(200, 'Tối đa 200 ký tự'),
    category: z.enum(['PAPER', 'INK', 'GLUE', 'FILM', 'CHEMICAL', 'OTHER']).optional(),
    subType: optStr(100),
    typeId: optStr(),
    vendorId: optStr(),
    specs: optStr(1000),
    gsm: optStr(20),
    width: z.coerce.number().min(0, 'Chiều rộng phải >= 0').optional(),
    length: z.coerce.number().min(0, 'Chiều dài phải >= 0').optional(),
    unit: optStr(20),
    unitPrice: z.coerce.number().min(0, 'Đơn giá phải >= 0').optional(),
    initialStock: z.coerce.number().min(0, 'Tồn ban đầu phải >= 0').optional(),
    currentStock: z.coerce.number().min(0, 'Tồn hiện tại phải >= 0').optional(),
    minStock: z.coerce.number().int().min(0, 'Tồn tối thiểu phải >= 0').optional(),
    note: optStr(1000),
    status: z.enum(['ACTIVE', 'INACTIVE']),
    image: optStr(),
    brand: optStr(100),
    height: z.coerce.number().min(0, 'Chiều cao phải >= 0').optional(),
    thicknessMicron: z.coerce.number().min(0, 'Độ dày phải >= 0').optional(),
    // ĐVT phụ (mua / đóng gói): 1 ĐVT phụ = hệ số × ĐVT chính (04/11/2026)
    secondaryUnit: optStr(20),
    secondaryFactor: z.coerce.number().min(0, 'Hệ số phải > 0').optional(),
    secondaryFactorAuto: z.boolean().optional(),
    packingNote: optStr(200),
});

export type MaterialFormData = z.infer<typeof materialFormSchema>;

export interface Material {
    id: string;
    materialId: string;
    name: string;
    typeId?: string | null;
    vendorId?: string | null;
    category?: 'PAPER' | 'INK' | 'GLUE' | 'FILM' | 'CHEMICAL' | 'OTHER' | null;
    subType?: string | null;
    specs?: string | null;
    gsm?: string | null;
    width?: number | null;
    length?: number | null;
    brand?: string | null;
    height?: number | null;
    unit?: string | null;
    initialStock?: number | null;
    currentStock?: number | null;
    minStock?: number | null;
    unitPrice?: number | null;
    note?: string | null;
    image?: string | null;
    status: 'ACTIVE' | 'INACTIVE';
    vendor?: { id: string; name: string } | null;
    materialType?: { id: string; name: string } | null;
    createdAt: string;
    updatedAt: string;
}
